import { Button, Modal } from '@payaca/ambrosia';
import { FC, useMemo, useState, type JSX } from 'react';

import './EntityTimelogsControl.sass';

import { TimelogsPermissions } from '@payaca/permissions/timelogs/timelogs.permissions';
import { TimelogLinkedEntity } from '@payaca/types/timelogs';
import AssigneeGroupedListedTimelogsControl from '../assigneeGroupedListedTimelogsControl/AssigneeGroupedListedTimelogsControl';
import CreateTimelogControl from '../createTimelogControl/CreateTimelogControl';
import ListedTimelogsControl from '../listedTimelogsControl/ListedTimelogsControl';
import { PermissionGuard } from '../permissionGuard/PermissionGuard';

type Props = {
  newTimelogsInitialStartTime?: Date;
  entity: Pick<TimelogLinkedEntity, 'entityType' | 'entityId'>;
  listedTimelogsViewType?: 'basic' | 'assignee-grouped';
  onDealUpdateSuccess?: () => void;
};
const EntityTimelogsControl: FC<Props> = ({
  newTimelogsInitialStartTime,
  entity,
  listedTimelogsViewType = 'basic',
  onDealUpdateSuccess,
}: Props): JSX.Element | null => {
  const [showCreateTimelogModal, setShowCreateTimelogModal] = useState(false);
  const [triggerRefreshDataAt, setTriggerRefreshDataAt] = useState<
    Date | undefined
  >();

  const initialFormState = useMemo(() => {
    return {
      primaryLinkedEntity: {
        entityId: entity.entityId,
        entityType: entity.entityType,
      },
      startTime: newTimelogsInitialStartTime,
    };
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useMemo has missing dependencies: 'entity.entityType', 'entity.entityId', and 'newTimelogsInitialStartTime'
  }, []);

  return (
    <div className="entity-timelogs-control">
      <PermissionGuard
        renderIfHasPermissions={[
          TimelogsPermissions.CREATE_SELF_ASSIGNED_TIMELOGS,
          TimelogsPermissions.CREATE_TIMELOGS,
        ]}
      >
        <div className="flex flex-row justify-end">
          <Button
            className="record-timelog-control"
            size={'sm'}
            onClick={() => setShowCreateTimelogModal(true)}
          >
            Record timelog
          </Button>
          <Modal
            title="Record a timelog"
            isOpen={showCreateTimelogModal}
            onClose={() => setShowCreateTimelogModal(false)}
          >
            <CreateTimelogControl
              initialFormState={initialFormState}
              onCreateTimelogSuccess={() => {
                setShowCreateTimelogModal(false);
                setTriggerRefreshDataAt(new Date());
                onDealUpdateSuccess?.();
              }}
            />
          </Modal>
        </div>
      </PermissionGuard>
      {listedTimelogsViewType === 'basic' && (
        <ListedTimelogsControl
          entity={entity}
          disableFilters={['periodStart', 'periodEnd']}
          triggerRefreshDataAt={triggerRefreshDataAt}
        />
      )}
      {listedTimelogsViewType === 'assignee-grouped' && (
        <AssigneeGroupedListedTimelogsControl
          entity={entity}
          disableFilters={['periodStart', 'periodEnd']}
          triggerRefreshDataAt={triggerRefreshDataAt}
        />
      )}
    </div>
  );
};
export default EntityTimelogsControl;
